module.exports = "<h1 id=\"realTimeTitle\">Real-time chart</h1>\r\n<svg #chart></svg>\r\n\r\n";